import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { HomeIcon, ClockIcon, BedDoubleIcon } from 'lucide-react';
export function HowItWorksSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="w-full bg-warmWhite py-20 px-4" data-id="element-123">
      <div className="max-w-5xl mx-auto" data-id="element-124">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-125">
          <h2 className="font-heading text-3xl sm:text-4xl text-charcoal mb-4" data-id="element-126">
            Cómo funciona
          </h2>
          <p className="font-body text-warmGray text-lg" data-id="element-127">
            Tres pasos simples hacia noches tranquilas
          </p>
        </motion.div>

        <motion.div className="relative" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-128">
          {/* Connection line - hidden on mobile */}
          <div className="hidden md:block absolute top-16 left-1/2 -translate-x-1/2 w-2/3 h-0.5 bg-gradient-to-r from-terracotta-200 via-terracotta-300 to-terracotta-200" data-id="element-129" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6" data-id="element-130">
            <motion.div className="relative flex flex-col items-center text-center" variants={itemVariants} data-id="element-131">
              <div className="relative z-10 w-16 h-16 bg-terracotta rounded-full flex items-center justify-center text-white font-heading text-2xl font-bold shadow-warm mb-6" data-id="element-132">
                1
              </div>
              <div className="w-14 h-14 bg-terracotta-100 rounded-2xl flex items-center justify-center mb-4" data-id="element-133">
                <HomeIcon className="w-7 h-7 text-terracotta" data-id="element-134" />
              </div>
              <h3 className="font-heading text-xl text-charcoal mb-3" data-id="element-135">
                Ajusta el Santuario
              </h3>
              <p className="font-body text-warmGray" data-id="element-136">
                Aplica el método R.E.P.O.S.O. en la habitación hoy mismo.
              </p>
            </motion.div>

            <motion.div className="relative flex flex-col items-center text-center" variants={itemVariants} data-id="element-137">
              <div className="relative z-10 w-16 h-16 bg-terracotta rounded-full flex items-center justify-center text-white font-heading text-2xl font-bold shadow-warm mb-6" data-id="element-138">
                2
              </div>
              <div className="w-14 h-14 bg-terracotta-100 rounded-2xl flex items-center justify-center mb-4" data-id="element-139">
                <ClockIcon className="w-7 h-7 text-terracotta" data-id="element-140" />
              </div>
              <h3 className="font-heading text-xl text-charcoal mb-3" data-id="element-141">
                Sincroniza Ventanas
              </h3>
              <p className="font-body text-warmGray" data-id="element-142">
                Usa la bitácora para acostar al bebé antes de que se
                sobreestimule.
              </p>
            </motion.div>

            <motion.div className="relative flex flex-col items-center text-center" variants={itemVariants} data-id="element-143">
              <div className="relative z-10 w-16 h-16 bg-terracotta rounded-full flex items-center justify-center text-white font-heading text-2xl font-bold shadow-warm mb-6" data-id="element-144">
                3
              </div>
              <div className="w-14 h-14 bg-terracotta-100 rounded-2xl flex items-center justify-center mb-4" data-id="element-145">
                <BedDoubleIcon className="w-7 h-7 text-terracotta" data-id="element-146" />
              </div>
              <h3 className="font-heading text-xl text-charcoal mb-3" data-id="element-147">
                Aplica Cero Llanto
              </h3>
              <p className="font-body text-warmGray" data-id="element-148">
                Usa las técnicas de transferencia de peso para consolidar el
                sueño profundo.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}